import { h, Fragment } from "preact";
import { ArrowRight } from "../helpers/icons";

export default function ShoppableImageProduct({ product }) {
  if (!product) return null;

  const variant = product.variants[0];
  const imageUrl =
    product.variants[0]?.image?.url || product.featuredImage?.url;

  const colorOption = product.options.find((entry) => entry.name === "Color");
  const colorCount = colorOption ? colorOption.optionValues.length : 0;

  return (
    <a href={product.helpers.url} className="shoppable-image-products__product">
      <div className="shoppable-image-products__product-content">
        {imageUrl && (
          <img
            className="shoppable-image-products__product-image"
            src={window.getSizedImageUrl(imageUrl, "x160")}
            alt={product.featuredImage?.altText || product.title}
          />
        )}
        <div className="shoppable-image-products__product-details">
          <div className="shoppable-image-products__product-title body">
            {product.title}
          </div>
          {colorCount > 0 && (
            <div className="shoppable-image-products__product-color-count caption-1">
              {theme.translations(
                window.localeStrings.shoppableProductImages,
                "color_count",
                {
                  count: colorCount,
                },
              )}
            </div>
          )}
        </div>
      </div>
      <div className="shoppable-image-products__product-icon">
        <ArrowRight />
      </div>
    </a>
  );
}
